import i18n from "shared/i18n";

export const percentValidation = value => {
  if (isNaN(Number(value))) {
    return i18n.t("Value must be a number");
  } else if (Number(value) < 0) {
    return i18n.t("Value must not be less than 0");
  } else if (Number(value) > 100) {
    return i18n.t("Value must not be more than 100");
  } else if (!isNaN(Number(value))) {
    if (!Number.isInteger(Number(value)) && String(value).split('.').pop().length > 2) {
      return i18n.t("More than 2 digits after point");
    }
  }
  return null;
};
